import { EDistributionGroupName } from '@/config/enums'

export const ru = {
  /**
   * ? Product name
   */
  'product.name.cyber-backup': 'Кибер Бэкап',
  'product.edition.advanced': 'Расширенная редакция',
  'product.edition.standard': 'Стандартная редакция',

  // ? Words
  'word.search': 'Поиск',

  // ? Dictionary
  'dictionary.key-count':
    '0 ключей | {count} ключ | {count} ключа | {count} ключей',
  'dictionary.support.key-count':
    'Поддержка 0 ключей | Поддержка {count} ключа | Поддержка {count} ключей',

  // ? Modals
  'modal.product-key.header.title': 'Ключ',
  'modal.adding-editing-comment.header.adding.title': 'Добавление комментария',
  'modal.adding-editing-comment.header.editing.title': 'Изменение комментария',
  'modal.header.title.contact-to-support': 'Обращение в техподдержку',
  'modal.download-product.header.title': 'Скачать дистрибутив: {name}',
  'modal.transfer-privileges.no-admins.description':
    'Для передачи прав суперадминистратора добавьте хотя бы одного администратора',
  'modal.transfer-privileges.description':
    'Права суперадминистратора будут переданы администратору',
  'modal.transfer-privileges.select-admin.description':
    'Выберите администратора, которому вы хотите передать права суперадминистратора',
  'modal.transfer-privileges.required-password':
    'Введите пароль для подтверждения',
  'modal.transfer-licenses.title': 'Передача ключей другому владельцу',
  'modal.feedback-support.title': 'Спасибо!',
  'modal.feedback-support.description':
    'Обращение № {issueId} зарегистрировано.\n' +
    'В ближайшее время мы с вами свяжемся.\n' +
    'Вы можете отслеживать статус своего обращения в списке обращений.',

  /**
   * ? COMPONENT: Notify
   */
  'component.notify.message-success.company-updated':
    'Изменены сведения о компании {name}',
  'component.notify.message-success.copy-serial-id': 'Серийный ключ скопирован',
  'component.notify.message-error.copy-serial-id':
    'Не удалось скопировать серийный ключ',
  'component.notify.message-error.branch-already-added':
    'Филиал {name} уже добавлен',
  'component.notify.message-error.branch-adding':
    'Произошла ошибка при добавлении филиала',
  'component.notify.message-success.branch-added': 'Добавлен филиал: {name}',
  'component.notify.message-success.branch-deleted': 'Удален филиал: {name}',
  'component.notify.message-success.person-deleted': 'Удален {role}: {name}',
  'component.notify.message-success.person-added': 'Добавлен {role}: {name}',
  'component.notify.message-success.transfer-privileges':
    'Права суперадминистратора переданы администратору: {name}',
  'component.notify.message-success.save-comment': 'Комментарий сохранен',
  'component.notify.message-error.save-comment':
    'Не удалось сохранить комментарий',
  'component.notify.message-success.clear-comment': 'Комментарий очищен',
  /**
   * ? Edition staff
   */
  'edition.staff.name.mailbox': 'Почтовый ящик',
  'edition.staff.name.mailbox-5': 'Почтовый ящик • 5 адресов',
  'edition.staff.name.mailbox-25': 'Почтовый ящик • 25 адресов',
  'edition.staff.name.mailbox-50': 'Почтовый ящик • 50 адресов',
  'edition.staff.name.mailbox-100': 'Почтовый ящик • 100 адресов',
  'edition.staff.name.mailbox-500': 'Почтовый ящик • 500 адресов',
  'edition.staff.name.mailbox-1000': 'Почтовый ящик • 1000 адресов',
  'edition.staff.name.workstation': 'Рабочая станция',
  'edition.staff.name.virtual-host': 'Виртуальный хост',
  'edition.staff.name.server': 'Сервер',
  'edition.staff.name.universal-license': 'Универсальная лицензия',
  'edition.staff.name.postgresql': 'PostgreSQL',

  /**
   * ? FIELDS: label
   */

  'field.label.to': 'до',
  'field.label.name:': 'Имя:',
  'field.label.search': 'Поиск',
  'field.label.order:': 'Заказ:',
  'field.label.email:': 'Email:',
  'field.label.data:': 'Данные:',
  'field.label.address:': 'Адрес:',
  'field.label.branch:': 'Филиал:',
  'field.label.phone': 'Телефон',
  'field.label.phone:': 'Телефон:',
  'field.label.company': 'Компания',
  'field.label.country:': 'Страна:',
  'field.label.surname:': 'Фамилия:',
  'field.label.product': 'Продукт',
  'field.label.user': 'Пользователь',
  'field.label.contact-details': 'Контактные данные',
  'field.label.attached-files': 'Прикрепленные файлы',
  'field.label.generated:': 'Сгенерирован:',
  'field.label.subscription-period:': 'Срок подписки:',
  'field.label.person': 'Контактное лицо',
  'field.label.email': 'Email',
  'field.label.owner': 'Владелец',
  'field.label.owner:': 'Владелец:',
  'field.label.contacts': 'Контакты',
  'field.label.status': 'Статус',
  'field.label.branch': 'Филиал',
  'field.label.created': 'Создано',
  'field.label.appeal': 'Обращение',
  'field.label.order-number': 'Номер заявки',
  'field.label.problem-description': 'Описание проблемы',
  'field.label.subject-of-address': 'Тема обращения',
  'field.label.commentary': 'Комментарий',

  /**
   * ? FORMS: label
   */
  'form.field.label.inn': 'ИНН',
  'form.field.label.unp': 'УНП',
  'form.field.label.kpp': 'КПП',
  'form.field.label.ogrn': 'ОГРН',
  'form.field.label.oked': 'ОКЕД',
  'form.field.label.company': 'Компания',
  'form.field.label.main-company': 'Основная компания',
  'form.field.label.branch': 'Филиал',
  'form.field.label.key': 'Ключ',
  'form.field.label.keys': 'Ключи',
  'form.field.label.generated': 'Сгенерирован',

  /**
   * ? Buttons: label
   */
  'button.group.all': 'Все',
  'button.group.only-my': 'Только мои',
  'button.action.clear': 'Очистить',
  'button.action.change': 'Изменить',
  'button.action.add': 'Добавить',
  'button.action.save': 'Сохранить',
  'button.action.cancel': 'Отменить',
  'button.action.copy': 'Скопировать',
  'button.action.edit': 'Редактировать',
  'button.action.transfer': 'Передать',
  'button.action.browse-all': 'Просмотреть все',
  'button.action.download-keys': 'Скачать ключи',
  'button.action.hide-comments': 'Скрыть комментарии',
  'button.action.show-comments': 'Показать комментарии',
  'button.action.to appeals': 'Перейти к обращениям',
  'button.action.add-admin': 'Добавить администратора',
  'button.action.add-comment': 'Добавить комментарий',
  'button.action.edit-comment': 'Изменить комментарий',
  'button.action.clear-comment': 'Очистить комментарий',
  'button.action.transfer-to-person': 'Передать другому владельцу',
  'button.action.contact-technical-support': 'Обратиться в техподдержку',

  /**
   * ? Breadcrumbs
   */
  'breadcrumbs.issue.title': 'Обращение в техподдержку',

  /**
   * ? FIELDS: validate
   */
  'form.field.validate.is-boolean': 'Недопустимое поле.',
  'form.field.validate.distribution.is-description':
    'Название уже существует в списке дистрибутивов раздела «{section}».',
  'form.field.validate.company-required': 'Выберите компанию.',

  /**
   * ? FIELDS: placeholder
   */
  'field.placeholder.select.search-company': 'Поиск по названию, ИНН и адресу',

  /**
   * ? COMPONENT: Tag
   */
  'component.tag.name.trial-license': 'Пробная версия',
  'component.tag.name.perpetual-license': 'Бессрочная',
  'component.tag.name.its-you': 'Это Вы',

  /**
   * ? COMPONENT: Buttons
   */
  'component.button.name.documentation': 'Документация',
  'component.button.name.try': 'Попробовать',
  'component.button.name.buy-full-version': 'Купить полную версию',
  'component.button.name.buy': 'Купить',
  'component.button.name.download-distribution': 'Скачать дистрибутив',
  'component.button.name.close': 'Закрыть',
  'component.button.name.add': 'Добавить',

  /**
   * ? COMPONENT: Select
   */
  'component.select.search.title.company-example':
    'Пример поиска (выводится до 20 результатов):',
  'component.select.search.text.company-name':
    'ООО “Ромашка”, 1234567890, Санкт-Петербург',

  /**
   * ? COMPONENT: Table
   */
  'component.table.cell.unlimited': 'Без ограничений',
  'component.table.cell.perpetual-key': 'бессрочный',
  'component.table.cell.order': 'Заказ {number}, {period}, {date}',

  /**
   * ? COMPONENT: Buttons
   */
  'component.button.name.next': 'Далее',
  'component.button.name.back': 'Назад',
  'component.button.name.send': 'Отправить',
  'component.button.name.cancel': 'Отменить',
  'component.button.name.re-enter': 'Перезайти',
  'component.button.name.buy-key': 'Купить ключ',
  'component.button.transfer-privileges': 'Передать права суперадминистратора',

  /**
   * ? COMPONENT: Stepper
   */
  'stepper.name.type-of-contact': 'Тип обращения',
  'stepper.name.contact-details': 'Контактные данные',
  'stepper.name.reporting-problem': 'Сообщение о проблеме',
  'stepper.description.data-pre-filled':
    'Ваши данные были предзаполнены. Проверьте правильность введенных данных и в случае ошибки измените их в своем Профиле.',
  'stepper.description.select-product':
    'Выберите продукт, в котором возникла проблема. Это позволит решить ваш вопрос быстрее.',
  'stepper.description.your-problem': 'Опишите вашу проблему',

  /**
   * ? COMPONENT: Popover
   */
  'component.popover.distribution.title':
    'Чтобы воспользоваться пробной версией',
  'component.popover.distribution.download': '1. Скачайте дистрибутив',
  'component.popover.distribution.install':
    '2. Установите продукт и активируйте пробную версию в продукте',

  /**
   * ? COMPONENT: Header
   */
  'component.header.title.products': 'Продукты',
  'component.header.title.undefined': 'Раздел не найден',
  'component.header.title.personal-account': 'Личный кабинет',
  'component.header.title.no-admins': 'Нет ни одного администратора',

  /**
   * ? COMPONENT: Tabs
   */
  'component.tab.short.contacting-support': 'В техподдержку',
  'component.tab.short.contacting-sales-department': 'В отдел продаж',
  'component.tab.contacting-support': 'Обращения в техподдержку',
  'component.tab.contacting-sales-department': 'Обращения в отдел продаж',

  /**
   * ? PAGE: Error
   */
  'page.errors.title.account-type-not-found': 'Не определен тип аккаунта',

  /**
   * ? PAGE: Products
   */
  'page.products.card.title.no-key': 'У вас еще нет ключа',
  'page.products.keys': 'Ключи продукта',
  'page.products.support-certificates': 'Сертификаты поддержки',
  'page.products.support-certificates.no-support': 'Нет поддержки',
  'page.products.support-certificates.status.all': 'Все',
  'page.products.support-certificates.status.expires': 'Истекает',
  'page.products.support-certificates.status.expired': 'Истек',
  'page.products.support-certificates.status.active': 'Действует',
  'page.products.support-certificates.status.acting': 'Действующие',
  'page.products.support-certificates.start-date': 'Начало действия',
  'page.products.support-certificates.end-date': 'Конец действия',
  'page.products.support-certificates.error': 'Не удалось загрузить данные',
  'page.products.order-number': 'Номер заказа',
  'page.products.licenses-count': 'Кол-во лицензий',
  'page.products.subscription-period': 'Срок подписки',
  'page.products.card.title.try-product': 'Вы хотите попробовать продукт',
  'page.products.card.text.perpetual-license':
    'Приобрести бессрочную лицензию или лицензии на основе подписки',
  'page.products.card.text.trial-version':
    'Выберите продукт и получите доступ к пробной полнофункциональной версии',

  /**
   * ? PAGE: Issues (support)
   */
  'page.issues.empty-content.title': 'Сейчас у вас нет обращений',

  /**
   * ? PAGE: Distributions
   */
  'page.distributions.product-list': 'Список продуктов',
  'page.distributions.versions:': 'Версии:',
  [EDistributionGroupName.OTHER]: EDistributionGroupName.OTHER,
  [EDistributionGroupName.INSTALLERS]: EDistributionGroupName.INSTALLERS,
  [EDistributionGroupName.VIRTUALIZATION_AGENT]:
    EDistributionGroupName.VIRTUALIZATION_AGENT,
  [EDistributionGroupName.AGENT_UPGRADE_PACKAGE]:
    EDistributionGroupName.AGENT_UPGRADE_PACKAGE,

  /**
   * ? PAGE: Profile
   */
  'page.profile.button.remove-profile': 'Удалить профиль',
  'page.profile.edit-company.title': 'Изменение сведений о компании',
  'page.profile.edit-branch.title': 'Изменение сведений о филиале',
  'page.profile.add-branch.title': 'Добавление филиала',
  'page.profile.remove-branch.title': 'Удалить филиал?',
  'page.profile.remove-person.title': 'Удалить контактное лицо?',
  'page.profile.add-person.title': 'Добавление контактного лица',
  'page.profile.remove-branch.description':
    'Удаление филиала необратимо. Введите пароль для подтверждения.',
  'page.profile.remove-branch.license-description':
    'В филиале числятся лица, которые могут иметь назначенные им ключи. Все неактивированные аккаунты удалятся из вашей структуры.',
  'page.profile.remove-branch.action-move': 'Перевести в основную компанию',
  'page.profile.remove-person.description':
    'Удаление контактного лица необратимо. Введите пароль для подтверждения.',
  'page.profile.remove-person.license-description':
    'Освободившиеся ключи будут переданы суперадминистратору',
  'page.profile.button.add-branch': 'Добавить филиал',
  'page.profile.not-specified': 'Не указано',
  'page.profile.company-unselected': 'Компания не выбрана',
  'page.profile.empty-contacts': 'Контактные лица компании не добавлены',
  'page.profile.can-add-admins':
    'Вы можете добавить администраторов и пользователей, а затем передать им ключи',
  'page.profile.cell.requisites': 'Реквизиты',
  'page.profile.cell.company-branches': 'Филиалы компании',
  'page.profile.cell.company-persons': 'Контактные лица',
  'page.profile.show-more': 'Показать ещё',
  'page.profile.add-person.description':
    'Администратор может добавлять других администраторов, пользователей и распределять между ними ключи',

  /**
   * ? Roles
   */
  'role.user': 'Пользователь',
  'role.admin': 'Администратор',
  'role.super-admin': 'Суперадминистратор',
}
